<mydocma-stepper [class.mydocma-mm-wt-steppert-mobile]="mobileMode" style="width: 100%;" [stepperConfig]="stepperConfig"
  (ready)="onReadyEvent($event)">
  <ng-template mydocmaStep="selectTemplate" let-step="step">
    <mydocma-mm-select-template-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-select-template-step>
  </ng-template>
  <ng-template mydocmaStep="selectOptions" let-step="step">
    <mydocma-mm-select-options-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-select-options-step>
  </ng-template>
  <ng-template mydocmaStep="showPreview" let-step="step">
    <mydocma-mm-preview-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-preview-step>
  </ng-template>
  <ng-template mydocmaStep="selectCreationType" let-step="step">
    <mydocma-mm-select-type-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-select-type-step>
  </ng-template>
  <ng-template mydocmaStep="selectEmail" let-step="step">
    <mydocma-mm-email-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-email-step>
  </ng-template>
</mydocma-stepper>